import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PreviewComponent, ToastComponent } from '@shared/ui';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    ConfirmDialogModule,
    ToastComponent,
    PreviewComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {}
